"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _icon = require("@alicd/next/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_Component) {
    (0, _inherits3.default)(Item, _Component);

    function Item(props, context) {
        (0, _classCallCheck3.default)(this, Item);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call(this, props, context));

        _this.state = {
            expanded: false,
            // "close", "open", "opening", "closing"
            expandedState: "close"
        };

        var newExpanded = _this.getNewExpanded(props, context);
        if (typeof newExpanded != "undefined" && newExpanded != _this.state.expanded) {
            _this.state.expanded = newExpanded;
        }
        if (_this.state.expanded) {
            _this.state.expandedState = "open";
        }

        _this.animTimeout = null;

        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Item, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            var newExpanded = this.getNewExpanded();
            var newExpandedState = this.state.expanded;
            if (typeof newExpanded != "undefined" && newExpanded != this.state.expanded) {
                this.setState({ expanded: newExpanded });
                newExpandedState = newExpanded;
            }
            if (prevState.expanded != newExpandedState) {
                this.updateExpandedState(newExpandedState);
            }
        }
    }, {
        key: "clearAndSetTimeout",
        value: function clearAndSetTimeout(f, timeout) {
            var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.context.cruiStorageNavMenuOpenTimeoutHandleContainer;

            if (container[0]) {
                clearTimeout(container[0]);
                container[0] = 0;
            }
            container[0] = setTimeout(f, timeout);
        }
    }, {
        key: "handleMouseEnter",
        value: function handleMouseEnter() {
            var _this2 = this;

            this.clearAndSetTimeout(function () {
                if (_this2.props.eventKey) {
                    _this2.context.cruiStorageNavHandleHover(_this2.props.eventKey);
                } else {
                    _this2.setState({ expanded: true });
                }
            }, this.context.cruiStorageNavMenuOpenTimeout);
        }
    }, {
        key: "handleMouseLeave",
        value: function handleMouseLeave() {
            var _this3 = this;

            this.clearAndSetTimeout(function () {
                if (_this3.props.eventKey) {
                    _this3.context.cruiStorageNavHandleExit(_this3.props.eventKey);
                } else {
                    _this3.setState({ expanded: false });
                }
            }, this.context.cruiStorageNavMenuOpenTimeout);
        }
    }, {
        key: "getNewExpanded",
        value: function getNewExpanded() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

            if (props.eventKey) {
                var newExpanded = false;
                if (props.eventKey == context.cruiStorageNavHoveredKey || context.cruiStorageNavItemsParent.has(context.cruiStorageNavHoveredKey) && context.cruiStorageNavItemsParent.get(context.cruiStorageNavHoveredKey).has(props.eventKey)) {
                    newExpanded = true;
                }
                return newExpanded;
            }
            return undefined;
        }
    }, {
        key: "updateExpandedState",
        value: function updateExpandedState(newExpanded) {
            var _this4 = this;

            if (newExpanded == false) {
                if (this.context.cruiStorageNavMenuAnimEnabledContainer[0]) {
                    if (this.state.expandedState == "opening") {
                        clearTimeout(this.animTimeout);
                        this.animTimeout = null;
                    }
                    this.animTimeout = setTimeout(function () {
                        _this4.setState({ expandedState: "close" });
                        _this4.animTimeout = null;
                    }, 400);
                    this.setState({ expandedState: "closing" });
                } else {
                    this.setState({ expandedState: "close" });
                }
            } else {
                if (this.context.cruiStorageNavMenuAnimEnabledContainer[0]) {
                    if (this.state.expandedState == "closing") {
                        clearTimeout(this.animTimeout);
                        this.animTimeout = null;
                    }
                    this.animTimeout = setTimeout(function () {
                        _this4.setState({ expandedState: "open" });
                        _this4.animTimeout = null;
                    }, 100);
                    this.setState({ expandedState: "opening" });
                } else {
                    this.setState({ expandedState: "open" });
                }
            }
        }
    }, {
        key: "renderChildren",
        value: function renderChildren() {
            var _this5 = this;

            if (!_react2.default.Children.count(this.props.children) || this.state.expandedState == "close") {
                return null;
            }
            var menuStyle = {
                zIndex: parseInt(-this.props.level - 2)
                // left: 211 * (this.props.level + 1)
            };
            return _react2.default.createElement(
                "div",
                { className: (0, _classnames2.default)("cn-stnav-item-child", {
                        "cn-stnav-expand-anim-enter": this.state.expandedState == "opening",
                        "cn-stnav-expand-anim-leave": this.state.expandedState == "closing"
                    }), key: "children" },
                _react2.default.createElement(
                    "div",
                    { className: "cn-stnav-menu", style: menuStyle },
                    _react2.default.createElement(
                        "div",
                        { className: "cn-stnav-menu-inner" },
                        _react2.default.createElement("div", { className: "cn-stnav-menu-bg" }),
                        _react2.default.Children.map(this.props.children, function (n, i) {
                            return _react2.default.cloneElement(n, {
                                level: _this5.props.level + 1,
                                parent: _this5,
                                eventKey: n.key || _this5.props.eventKey + "-" + i
                            });
                        })
                    )
                )
            );
        }
    }, {
        key: "render",
        value: function render() {
            var hasChild = !!_react2.default.Children.count(this.props.children);
            return _react2.default.createElement(
                "div",
                {
                    className: (0, _classnames2.default)("cn-stnav-item", {
                        "cn-stnav-item-nonleaf": hasChild,
                        "cn-stnav-active": this.state.expanded
                    }),
                    onMouseEnter: this.handleMouseEnter,
                    onMouseLeave: this.handleMouseLeave
                },
                _react2.default.createElement(
                    "div",
                    { className: (0, _classnames2.default)("cn-stnav-item-head"), onClick: this.props.onClick },
                    _react2.default.createElement(
                        "div",
                        { className: "cn-stnav-item-title" },
                        this.props.title
                    ),
                    (0, _util.showIf)(hasChild, function () {
                        return _react2.default.createElement(_icon2.default, {
                            className: "cn-navfold-item-arrow cn-stnav-item-arrow",
                            type: "arrow-right",
                            size: "small"
                        });
                    }),
                    (0, _util.showIf)(hasChild, function () {
                        return _react2.default.createElement("div", { className: "cn-stnav-line-placeholder" });
                    })
                ),
                (0, _util.showIf)(hasChild, function () {
                    return _react2.default.createElement("div", { className: "cn-stnav-child-border" });
                }),
                this.renderChildren()
            );
        }
    }]);
    return Item;
}(_react.Component);

Item.propTypes = {
    title: _propTypes2.default.node,
    onClick: _propTypes2.default.func,
    level: _propTypes2.default.number,
    eventKey: _propTypes2.default.string,
    parent: _propTypes2.default.object
};
Item.contextTypes = {
    cruiStorageNavHoveredKey: _propTypes2.default.string,
    cruiStorageNavHandleHover: _propTypes2.default.func,
    cruiStorageNavHandleExit: _propTypes2.default.func,
    cruiStorageNavItemsParent: _propTypes2.default.object,
    cruiStorageNavMenuOpenTimeout: _propTypes2.default.number,
    cruiStorageNavMenuOpenTimeoutHandleContainer: _propTypes2.default.object,
    cruiStorageNavMenuAnimEnabledContainer: _propTypes2.default.object
};
exports.default = Item;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-storage-nav@0.0.16@@alicd/crui-storage-nav/lib/Item.js
// module id = 676
// module chunks = 0